module.exports = __webpack_public_path__ + "static/thunderwave_mtg_clb-512c810e5b677ff0bdd80e006648e113.webp";